import { Pipe, PipeTransform } from '@angular/core';
import { ElementParse } from '../ParseClass/Element.Parse';

@Pipe({
    name: 'getElementById',
    pure: true,
    standalone: false
})
export class GetElementByIdPipe implements PipeTransform {

  transform(objectId: string, elements: ElementParse[] | undefined): ElementParse | undefined {
    if (!objectId || !elements || !Array.isArray(elements)) {
      return undefined;
    }
    return elements.find(e => e.objectId === objectId);
  }
}